<template>
  <div>
    <div class="keyword-search-wrapper">
      <div class="keyword-search">
        <md-field
          md-clearable
          class="keyword-search__keyword-input"
          :class="{ 'md-invalid': noHits }"
        >
          <gl-icon-search />
          <label>検索ワード</label>
          <md-input ref="text" type="text" :value="text" @input="updateText" />
          <span class="md-error">メーカーが見つかりませんでした</span>
        </md-field>
      </div>
    </div>
    <div class="suppliers-container">
      <supplier-list
        :suppliers="suppliers"
        :selected.sync="selected"
        selectable
      />
      <div v-if="supplierFountExceedsLimit" class="message-max-count-exceeds">
        検索結果上位{{ maxSearchCount }}件を表示しています
      </div>
      <div class="fetching" v-if="fetching">
        <spinner />
      </div>
    </div>
    <div class="button-group">
      <gl-button
        dense
        primary
        icon-pre="list-add"
        class="button-group__button"
        :disabled="suppliers.length === 0"
        @click=";(selected = suppliers), $emit('selected', selected)"
      >
        All
      </gl-button>
      <gl-button
        dense
        primary
        class="button-group__button"
        :disabled="selected.length === 0"
        @click="$emit('selected', selected)"
      >
        <gl-icon-list-add />
      </gl-button>
    </div>
  </div>
</template>

<script>
import { Subject, from, of } from 'rxjs'
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  switchMap,
} from 'rxjs/operators'
import SupplierList from '@/components/SupplierList.vue'
import Spinner from '@/components/Spinner.vue'

export default {
  components: { SupplierList, Spinner },
  props: {
    /**
     * 検索時、最大で表示するメーカー数
     *
     * 検索結果（Array）の先頭x件を表示します。並び順はリポジトリがどの
     * 順番で返すかに依存します。
     */
    maxSearchCount: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      /**
       * 検索テキスト
       */
      text: undefined,
      /**
       * 検索テキスト変更Subject
       */
      textSubject: new Subject(),
      /**
       * 検索中
       */
      fetching: false,
      /**
       * 検索テキストでのヒットなし
       */
      noHits: false,
      /**
       * 検索したメーカー数
       */
      supplierFoundCount: 0,
      /**
       * 選択肢に表示するメーカー
       */
      suppliers: [],
      /**
       * 選択されているメーカー
       */
      selected: [],
    }
  },
  computed: {
    /**
     * 検索した結果が表示最大件数をオーバーしているか
     */
    supplierFountExceedsLimit() {
      return this.supplierFoundCount > this.maxSearchCount
    },
  },
  methods: {
    /**
     * 検索ワード変更
     */
    updateText(v) {
      this.text = v
      this.textSubject.next(v)
    },
  },
  mounted() {
    // エントリー名絞込のトリガーです
    // 絞込テキストの入力があるとfilterTextSubjectに通知をするので、
    // 適度なタイミング（xxx ms入力が止まっている and 前回と値が違う）で
    // 実際の絞り込み処理を行います。
    const subscription = this.textSubject
      .asObservable()
      .pipe(
        debounceTime(400),
        distinctUntilChanged(),
        tap(() => {
          this.fetching = true
        }),
        map(text => text.trim()),
        switchMap(text => {
          if (!text) {
            return of([])
          } else {
            return from(this.$supplier.getByKeyWord(text))
          }
        }),
      )
      .subscribe(result => {
        this.noHits = result.length === 0
        this.supplierFoundCount = result.length
        this.suppliers = result.slice(0, this.maxSearchCount)
        this.selected = []
        this.fetching = false
      })

    this.$on('hook:beforeDestroy', () => subscription.unsubscribe())

    // 入力欄にフォーカスを自動で当てたいが、ダイアログ内にこのコンポーネントを置いた場合、
    // 少し待たないとfocusが効かなかった（$elではちゃんとinput要素が取れていたが）。
    setTimeout(() => {
      this.$refs.text.$el.focus()
    }, 500)
  },
}
</script>

<style lang="scss" scoped>
.suppliers-container {
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid var(--color-border);
  border-radius: 5px;
}

.keyword-search-wrapper {
  margin-top: var(--spacing-medium);
}

.keyword-search {
  width: 100%;
  display: flex;
  align-items: center;

  &__keyword-input {
    flex: 1;
  }
}

.message-max-count-exceeds {
  color: #ff7043; // TODO 色ちゃんとする
  width: 100%;
  text-align: center;
}

.fetching {
  background: rgba($color: #000000, $alpha: 0.2);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
}
</style>
